import React, {useEffect} from "react";
import {useAuth0} from '@auth0/auth0-react';
import {useNavigate} from 'react-router-dom';
import Loading from "../common/Loading";
import NotFound from "../common/NotFound";

//When the user logs in through Auth0, they are redirected to /callback.
//If they are authenticated, they will be redirected to the dashboard page.

export default function Callback() {
    const {isAuthenticated, error, isLoading} = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, navigate]);


    //header, content, pathUrl, pathName}
    if (isLoading) return <Loading />
    if (error) return <NotFound header="Login Error!" content={error.message} path="/callback" pathName="Login Callback"/>

    return <div>Logging in...</div>
}